<template>
  <div>
    <QueryFrame
      @handlePage="handlePage"
      @handlePageSize="handlePageSize"
      :count="count"
      :current="page">
      <div slot="queryParams" class="queryContainer">
        <div class="queryItem" v-if="roleType!==2">
          <label>门店名称:</label>
          <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
        </div>
        <div class="queryItem">
          <goodsSearchItem v-model="query.nameMix"></goodsSearchItem>
        </div>
        <div class="queryItem">
          <label>养护规则:</label>
          <lk-select class="item" clearable filterable v-model.trim="query.curingRuleId" placeholder="全部">
            <lk-option v-for="item in curingRuleList" :key="item.id" :value="item.id">{{item.name}}</lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label>养护标准:</label>
          <lk-select class="item" clearable v-model.trim="query.standard" placeholder="全部">
            <lk-option v-for="(item, index) in standardMap" :key="index" :value="item[0]">{{item[1]}}</lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label>商品类型:</label>
          <lk-select class="item" v-model="query.type" clearable>
            <lk-option v-for="(item, index) in getNormalGoodsTypes" :key="index" :value="item.value">{{item.name}}</lk-option>
          </lk-select>
        </div>

        <div class="queryItem">
          <label>来源:</label>
          <lk-select class="item" v-model="query.purchaseType" clearable>
            <lk-option v-for="(item, index) in getGoodsOrigin" :key="index" :value="item.value">{{item.name}}</lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label>养护时间</label>
          <timeStampDatePicker type="daterange" placeholder="请选择" class="item" v-model.trim='query.duration' ></timeStampDatePicker>
        </div>
        <div class="queryItem">
          <lk-button type="primary" class="mr" @click="handleSearch(false, clearTemp)">查询</lk-button>
          <lk-button @click="handleReset">重置</lk-button>
        </div>
      </div>
      <div slot="table">
        <div class="btn-wrap mb16">
          <span v-if="true || this.handlePermission('printCuring')">
            <lk-button class="mr8" type="primary" @click="getSelectedPrintData" :disabled="tempPrintIds.length === 0">打印所选</lk-button>
            <lk-button class="mr8" type="primary" @click="getAllPrintData">打印所有</lk-button>
          </span>
        </div>

        <lk-table border :columns="columns" :data="tableData"
          @on-select="handleTempSelect"
          @on-select-cancel="handleTempCancel"
          @on-select-all="handleSelectAll"
          @on-select-all-cancel="handleSelectAllCancel"
          ></lk-table>
      </div>
    </QueryFrame>
    <LinkQR015 ref="LinkQR015"></LinkQR015>
    <LinkQR013 ref="LinkQR013"></LinkQR013>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import QueryFrame from '../../components/frame/QueryFrame.vue';
import inventory from '../../services/inventory';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import LinkQR015 from '../../components/print/LinkQR015.vue';
import LinkQR013 from '../../components/print/LinkQR013.vue';

export default {
  name: 'curingHistory',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame, LinkQR015, LinkQR013,
  },
  computed: {
    ...mapGetters([
      'getGoodsOrigin',
      'getNormalGoodsTypes',
    ]),
    hasCuringReCheckView() {
      return this.handlePermission('curingReCheckView');
    },
  },
  data() {
    return {
      tempPrintIds: [],
      curingRuleList: [],
      standardMap: new Map([
        [1, '一般养护'],
        [2, '重点养护'],
      ]),
      query: {
        storeIdList: [],
        nameMix: null,
        curingRuleId: null,
        standard: null,
        alertDays: null,
        type: null, // 商品类型
        purchaseType: 1, // 来源
      },
      tableData: [],
      columns: [
        {
          type: 'selection',
          minWidth: 60,
          align: 'center',
          fixed: 'left',
        },
        {
          title: '序号',
          type: 'index',
          minWidth: 80,
          indexMethod: row => (row._index + this.size * (this.page - 1)) + 1,
        },
        {
          title: '商品编码',
          key: 'curingReCheckRecordDrugSerialCode',
          minWidth: 110,
        },
        {
          title: '商品名称',
          key: 'curingReCheckRecordGoodsName',
          minWidth: 110,
        },
        {
          title: '通用名称',
          key: 'curingReCheckRecordApprovedDrugNames',
          minWidth: 110,
        },
        {
          title: '规格',
          key: 'curingReCheckRecordSpecifications',
          minWidth: 110,
        },
        {
          title: '生产厂家',
          key: 'curingReCheckRecordManufacturer',
          minWidth: 110,
        },
        {
          title: '上市许可持有人',
          minWidth: 120,
          tooltip: true,
          key: 'mah',
        },
        {
          title: '剂型',
          key: 'curingReCheckRecordDosageForm',
          minWidth: 110,
        },
        {
          title: '单位',
          key: 'curingReCheckRecordDrugMiniPackageUnit',
          minWidth: 110,
        },
        {
          title: '批号',
          key: 'curingReCheckRecordGoodsBatchNumber',
          minWidth: 110,
        },
        {
          title: '批次',
          key: 'curingReCheckRecordGoodsBatchSeq',
          minWidth: 110,
        },
        {
          title: '养护标准',
          key: 'curingReCheckRecordStandardStr',
          minWidth: 110,
        },
        {
          title: '仓库',
          key: 'curingReCheckRecordWarehouseName',
          minWidth: 110,
        },
        {
          title: '货位',
          key: 'curingReCheckRecordLocationCode',
          minWidth: 110,
        },
        {
          title: '供应商',
          key: 'curingReCheckRecordSupplierName',
          minWidth: 110,
        },
        {
          title: '养护数量',
          key: 'curingReCheckRecordCuringCount',
          minWidth: 110,
        },
        {
          title: '养护内容',
          key: 'curingReCheckRecordContent',
          minWidth: 110,
        },
        {
          title: '养护结果',
          key: 'curingReCheckRecordCuringResultStr',
          minWidth: 130,
        },
        {
          title: '存疑数量',
          key: 'curingReCheckRecordDoubtfulCount',
          minWidth: 130,
        },
        {
          title: '养护时间',
          key: 'curingReCheckRecordModifiedTime',
          minWidth: 130,
        },
        {
          title: '养护人员',
          key: 'curingReCheckRecordModifiedUserName',
          minWidth: 110,
        },
        {
          title: '养护规则',
          key: 'curingReCheckRecordCuringRuleName',
          minWidth: 110,
        },
        {
          title: '商品类型',
          key: 'goodsTypeName',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '来源',
          key: 'curingReCheckRecordPurchaseTypeName',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '操作',
          key: 'addBtn',
          minWidth: 130,
          fixed: 'right',
          render: (h, { row }) => (this.hasCuringReCheckView ? h('lk-button', {
            props: {
              type: 'text',
              disabled: row.curingReCheckRecordDoubtfulCount === 0,
            },
            on: {
              click: () => {
                const id = row.curingReCheckRecordReCheckReportId;
                this.$router.push({
                  name: 'curingReCheckView',
                  params: { id },
                });
              },
            },
          }, '查看复查单') : null),
        },
      ],
    };
  },
  methods: {
    clearTemp() {
      this.tempPrintIds = [];
    },
    getCuringRules() {
      return inventory.curingRuleList({ status: 1 }).then((res) => {
        if (res.data.status === 200) {
          const { list } = res.data.data;
          this.curingRuleList = [];
          list.forEach((item) => {
            this.curingRuleList.push(item.curingRule);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      if (this.params.duration && this.params.duration.length === 2) {
        this.params.curingStartDate = this.params.duration[0];
        this.params.curingEndDate = this.params.duration[1];
        delete this.params.duration;
      }
      inventory.curingRecordListNew(this.params).then((res) => {
        if (res.data.status === 200) {
          const { count, list } = res.data.data;
          this.tableData = [];
          list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.curingReCheckRecordStandardStr = this.standardMap.get(result.curingReCheckRecordStandard);
            result.curingReCheckRecordCuringResultStr = `正常数量${utils.fixNumber(result.curingReCheckRecordCuringCount - result.curingReCheckRecordDoubtfulCount, 2) || 0}, 存疑数量${result.curingReCheckRecordDoubtfulCount || 0}`;
            if (!result.curingReCheckRecordModifiedTime) {
              result.curingReCheckRecordModifiedTime = '-';
            } else {
              result.curingReCheckRecordModifiedTime = utils.exchangeTime(result.curingReCheckRecordModifiedTime);
            }
            if (!result.curingReCheckRecordModifiedUserName) {
              result.curingReCheckRecordModifiedUserName = result.curingReCheckRecordCreateUserName;
            }
            result.curingReCheckRecordNextTime = utils.exchangeTime(result.curingReCheckRecordNextTime);
            if (this.tempPrintIds.includes(result.curingReCheckRecordId)) {
              result._checked = true;
            }
            result.curingReCheckRecordContent = '检查存储条件、包装质量、外观质量';
            this.tableData.push(result);
          });
          this.count = count;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleReset() {
      this.query = {};
    },
    handleTempSelect(selection, row) {
      if (!this.tempPrintIds.includes(row.curingReCheckRecordId)) {
        this.tempPrintIds.push(row.curingReCheckRecordId);
      }
    },
    handleTempCancel(selection, row) {
      for (let i = 0, len = this.tempPrintIds.length; i < len; i++) {
        if (this.tempPrintIds[i] === row.curingReCheckRecordId) {
          this.tempPrintIds.splice(i, 1);
          break;
        }
      }
    },
    handleSelectAll(selection) {
      selection.forEach((item) => {
        if (!this.tempPrintIds.includes(item.curingReCheckRecordId)) {
          this.tempPrintIds.push(item.curingReCheckRecordId);
        }
      });
    },
    handleSelectAllCancel() {
      this.tableData.forEach((good) => {
        for (let i = 0, len = this.tempPrintIds.length; i < len; i++) {
          if (this.tempPrintIds[i] === good.curingReCheckRecordId) {
            this.tempPrintIds.splice(i, 1);
            break;
          }
        }
      });
    },
    getAllPrintData() {
      console.log(this.tempPrintIds);
      if (this.count > 1000) {
        this.$Message.error('最多支持1000条同时打印，请分批提交');
        return;
      }
      if (this.count == 0) {
        this.$Message.error('当前条件没有结果，请重新查询');
        return;
      }
      let params = utils.deepClone(this.params);
      params = utils.deletePageAndSize(params);
      this.getPrintData(params);
    },
    getSelectedPrintData() {
      const params = {
        curingDetailIdList: this.tempPrintIds,
      };
      this.getPrintData(params);
    },
    getPrintData(params) {
      inventory.getCuringPrintData(params).then((res) => {
        if (res.data.status === 200) {
          console.log(res);
          const { hasCommon, curingRecheckDetailVoList } = res.data.data;
          if (curingRecheckDetailVoList.length == 0) {
            this.$Message.error('当前条件没有结果，请重新查询');
            return;
          }
          if (hasCommon == 2) {
            // LinkQR015 重点
            this.$refs.LinkQR015.handlePrint(curingRecheckDetailVoList);
          } else {
            // Lin kQR013 一般
            this.$refs.LinkQR013.handlePrint(curingRecheckDetailVoList);
          }
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    this.getCuringRules();
    this.handleSearch(true);

    if (!this.hasCuringReCheckView) {
      this.columns.pop();
    }

    if (this.roleType !== 2) {
      this.columns.splice(2, 0, { title: '门店名称', key: 'curingReCheckRecordStoreName', minWidth: 116 });
    }
  },
};
</script>
<style lang="less" scoped>
</style>
